import React from 'react';
import { RectShape, TextBlock } from '@thd-olt-component-react/loading-placeholder';

export const ProductPodPlaceholder = () => (
  <>
    <RectShape style={{ width: '100%', height: '250px', marginBottom: '10px' }} color="#E0E0E0" />
    <TextBlock rows={7} color="#E0E0E0" />
  </>
);
